import dwUtils from '../../util';
import dwValidator from '../../validator';

import * as Utils from '../../helpers/born.utils';
import Megamenu from '../module.megamenu';
import Fixit from '../module.fixit';
import {breakpoints, toggleOverlay, isMobile, shouldEnableSticky} from '../../helpers/born.utils';
import Modal from '../module.modal';
import TrackingLayer from '../../modules/module.tracking-layer';

var page = require('../../page'),
    util = require('../../util');

/**
 * Navigation::
 * Bunch of useless things.
 * Making stuff work on tablet and desktops. When is touch device media query coming to CSS?
 */

var mainNav,
    fixedNav,
    welcomeMat,
    signup,
    gdprModal,
    matContent = document.querySelector('.modal--welcomemat__content'),
    signupContent = document.querySelector('.modal--signup__content'),
    gdprContent = document.querySelector('.js-gdpr-modal');

const NAV_OPTIONS = {
	menu: ".header__catmenu",
    triggers: ".header__catmenu__anchor,.flyout-col__heading",
    target: ".header__catmenu__sub,.flyout-col__all_item",
    beforeItemSet: onSetNav,
    afterItemUnset: onUnsetNav,
    waitForAnimateEl: ".header__catmenu__sub,.flyout-col__all_item",
    allowClickThrough: "level-1",
    afterMenuSet: showOverlay,
    afterMenuUnset: hideOverlay,
    flyOutDisabled: 'js-no-flyout',
	responsive: [
        {
            breakpoint: breakpoints.mobile,
            settings: {
                events: 'click',
                unsetOnMouseleave: false,
                cancelCloseSelf: false,
                allowClickThrough: 'second-level-cat',
                allowClickThroughDirectly: 'direct'
            }
        }
	]
};

const FIXIT_OPTIONS = {
    target: document.querySelector('.header__main'),
    enabled: shouldEnableSticky
};

const MAT_OPTIONS = {
    modalID:        'welcomeMatOverlay',
    modalClass:     'modal--welcomemat',
    modalContent:   matContent,
    beforeOpenCallback: beforeMatOpen,
    afterCloseCallback: afterMatClose
};

const SIGNUP_OPTIONS = {
    modalID:        'signupOverlay',
    modalClass:     'modal--signup',
    modalContent:   signupContent,
    beforeOpenCallback: beforeSignupOpen,
    afterCloseCallback: afterSignupClose
};

const GDPR_OPTIONS = {
    modalID:    'gdprOverlay',
    modalClass:     'modal-gdpr',
    modalContent:   gdprContent,
    beforeOpenCallback: beforeGDPROpen,
    afterCloseCallback: afterGDPRClose,
    isCloseBlocked: true
};

function beforeMatOpen(overlay) {
    document.documentElement.classList.add('cancel-scroll--force');
    matContent.classList.remove('hidden');
}

function afterMatClose() {
    document.documentElement.classList.remove('cancel-scroll--force');
}

function beforeSignupOpen(overlay) {
    document.documentElement.classList.add('cancel-scroll--force');
    signupContent.classList.remove('hidden');
}

function afterSignupClose() {
    document.documentElement.classList.remove('cancel-scroll--force');
}

function beforeGDPROpen(overlay) {
    // Disable scrolling and make popup visible
    $(document).addClass('cancel-scroll--force');
    $(gdprContent).removeClass('hidden');

    // GDPR Events
    $('.js-gdpr-modal button').click(function (e) {
        e.preventDefault();

        var $form = $(this).closest('form'),
            buttonName = $(this).attr('name'),
            buttonVal = $(this).val(),
            url = util.appendParamToURL($form.attr('action'), buttonName, buttonVal);

        // Tracking layer
        if ($(this).hasClass('js-gdpr-submit')) {
            TrackingLayer.pushData('gdpr_tracking: ' + window.Resources['GDPR_ON']);
        } else if ($(this).hasClass('js-gdpr-discard')) {
            TrackingLayer.pushData('gdpr_tracking: ' + window.Resources['GDPR_OFF']);
        }
        
        // Send request
        $.ajax({
            url: url,
            type: 'POST',
            data: $form.serialize(),
            complete: function(response) {
                page.refresh();
            }
        });
    });
}

function afterGDPRClose() {
    $(document).removeClass('cancel-scroll--force');
}

function onSetNav(trigger) {
    loadFlyoutImages(trigger);
    toggleNavStyles(trigger, true);
}

function onUnsetNav(trigger) {
    toggleNavStyles(trigger);
}

function showOverlay() {
    toggleOverlay(true, false, false);
}

function hideOverlay() {
    toggleOverlay(false, false, false);
}

function loadFlyoutImages(el)
{
    if( SitePreferences.ENABLE_IMAGE_LAZYLOAD && window.innerWidth >= breakpoints.mobile ) {
        var activeEl = $(el).closest('.header__catmenu__item.level-1').find(".flyout-col__cta__images img:not(.unveil-loaded)");
        if(activeEl.length > 0) {
            activeEl.unveil(300, function () {
                $(this).addClass('unveil-loaded');
            });
        } else {
            $(".flyout-col__cta__images img:not(.unveil-loaded)").unveil(300, function () {
                $(this).addClass('unveil-loaded');
            });
        }
    }
}

function toggleNavStyles(trigger, isShow) {

    /**
     * [adds a class to the closest scrollable nav to disable scrolling,
     * fixing a mobile Safari bug on child scrollable views]
     */
    if( window.innerWidth < breakpoints.mobile ) {
        var scrollableNav;

        if( trigger.classList.contains('level-1') ) {
            scrollableNav = document.querySelector('.header__secondary__content');
        }

        else {
            scrollableNav = $(trigger).closest('.header__catmenu__sub')[0];
        }

        if( isShow ) {
            scrollableNav.classList.add('megamenu--prev-nav');
        }

        else {
            scrollableNav.classList.remove('megamenu--prev-nav');
        }
    }
    if(SitePreferences.ENABLE_IMAGE_LAZYLOAD && window.innerWidth < breakpoints.mobile) {
        $("img.product__img:not(.unveil-loaded)").trigger("unveil");
        var activeEl = $(trigger).closest('.level-1').find("img.header--flyout__img:not(.unveil-loaded)");
        if(activeEl && activeEl.length > 0) {
            activeEl.unveil(4000, function() {
                $(this).addClass('unveil-loaded');
            });
        } else {
           $("img.header--flyout__img:not(.unveil-loaded)").unveil(4000, function() {
                $(this).addClass('unveil-loaded');
            });
        }
    }
}

function setNavInteractions(){
    var header = document.querySelector('.header'),
        secondaryNav = document.querySelector('.header__secondary'),
        countryDropdown = document.querySelector('.header__sett__country .header__sett__list'),
        langDropdown = document.querySelector('.header__sett__lang .header__sett__list'),
        logoDropdown = document.querySelector('.header__tagline__descr'),
        scrollableNav = document.querySelector('.header__secondary__content'),
        promoBanner =  document.querySelector('.header__promo-banner');

    //Hooking functionality to toggle no-scroll on page wrapper on mobile main nav show/hide
    if(secondaryNav !== null) {
        secondaryNav.beforeContentShow = function () {
            // document.documentElement.classList.add('cancel-scroll');
            document.body.classList.add('cancel-scroll');

            scrollableNav.scrollTop = 0;
            let promoBannerHeight = promoBanner.getBoundingClientRect().height;
            let sideNavHeight = `calc(100dvh - ${promoBannerHeight}px)`;

            let currentScrollPos = window.scrollY || document.documentElement.scrollTop;
            var fixitHeader = document.querySelector('.header__main.fixit--active');
            if (fixitHeader) {
                sideNavHeight = '100dvh'
            } else if (currentScrollPos < promoBannerHeight) {
                sideNavHeight = `calc(100dvh - ${promoBannerHeight - currentScrollPos}px)`;
            }

            secondaryNav.style.height = sideNavHeight;

            toggleOverlay(true);

            return true;
        };

        secondaryNav.afterContentHide = function () {
            // document.documentElement.classList.remove('cancel-scroll');
            document.body.classList.remove('cancel-scroll');
            secondaryNav.style.height = '';

            toggleOverlay(false);
        };
    }
    if(logoDropdown){
	    logoDropdown.beforeContentShow = function(){
	        toggleOverlay(true);
	
	        return true;
	    };
	
	    logoDropdown.afterContentHide = function(){
	        toggleOverlay(false);
	    };
    }
    if(langDropdown) {
    langDropdown.afterContentShow= function(trigger) {
        scrollableNav.scrollTop = trigger.offsetTop;
    };
    }
    if(countryDropdown){
    countryDropdown.afterContentShow = function(trigger) {
        scrollableNav.scrollTop = trigger.offsetTop;
    };
    }
    //Disable country/language from unsetting other active elements.
    //This is to prevent this trigger from closing the main nav.
    if(countryDropdown){
    countryDropdown.beforeUnsetOthers = toggleSetting;
    }
   
    if(langDropdown) {
        langDropdown.beforeUnsetOthers = toggleSetting;
    }
    
    function toggleSetting() {
        if(window.innerWidth < breakpoints.mobile){
            return false;
        }

        return true;
    }
}

function addSignupHandler() {
    //dwValidator.settings.onfocusout = false;

    let form = document.querySelector('.modal--signup__subscribe__form'),
        subFormSettings = $.extend(true, {submitHandler: sendSignupRequest}, dwValidator.settings);

    $(form).find('input').on('change', function(){
        $(this).closest('.modal--signup__details').find('.modal--signup__subscribe__message').remove();
    });

    $('.modal--signup__later').on('click', function(){
        $(form).closest('.window-overlay--modal').find('.window-overlay--close').click();
    });

    if(isMobile.Android()){
        $(form).find('input.modal--signup__emailsignup').on('focus', function(){
            setTimeout(function() {
                $('.overlay--active').scrollTop( $(form).offset().top );
            }, 500);
        });
    }

    dwValidator.initForm(form, subFormSettings);
}

function sendSignupRequest(form) {
    

    $.ajax({
        url: dwUtils.ajaxUrl($(form).attr('action')),
        data: $(form).serialize(),
        complete: function(response) {

            $(form).closest('.window-overlay--modal').find('.window-overlay--close').click();

            let responseContent = JSON.parse(response.responseText);

            Utils.createMessageBanner(responseContent.message);

            TrackingLayer.pushData('mail_signup: ' + window.Resources['USER_SIGNUP']);
        }
    });

    return false;
}

function togglePromoBanner() {
    var items = $('.header__promo-banner .item'),
    totalItems = items.length,
    currentItem = 1; // start from the second item since the first item is displayed by css

    if(totalItems > 1) {

        setInterval(function() { 

            items.hide();
            items.eq(currentItem).show();

            if(currentItem < totalItems) {
                currentItem++;
            }

            if(currentItem == totalItems) {
                currentItem = 0;
            }

        }, 5000);
    }
}

function focusHeaderSearch() {
    var $searchInput = $('.header__search__input');
    var $searchTrigger = $('.js-header-search-trigger');

    $searchTrigger.on('click', (e) => {
        $searchInput.focus();
        if ($(window).width() > 767) {
            $('.header__search--backdrop').toggleClass('hidden');
            $('html, body').toggleClass('no-scroll');
        }
        // Push to data layer
        var user = dataLayer.find(o => o.user != null).user;
        if (!$('.js-header-search-trigger').hasClass('toggle--active')) {
            onSearchPopUpClose(user);
        } else {
            dataLayer.push({
                'event': 'custom_event',
                'eventCategory': 'search',
                'eventAction': 'go_to_search',
                'eventLabel': 'go to search',
                'country': window.GlobalAttributes.COUNTRY,
                'language': window.GlobalAttributes.LANGUAGE,
                'screenName' : 'Search',
                'userType': user.user_id!='' ? 'logged-in' : 'logged-out',
                'userId': user.user_id!='' ? user.user_id : ''
            });
        }
    });

    $('.header__search__form').on('submit',function(e) {
        var searchObj = $(this).find('input[name="q"]');
        if(searchObj.length > 0) {
            if(searchObj.val().trim() == '') {
                e.preventDefault();
                searchObj.addClass('error');
            } else {
                searchObj.removeClass('error');
            }
        }
    })
}

function closeSearchPopup() {
    $('.search-titlebar-mobile .close-icon').on('click', () => {
        $('button.js-header-search-trigger').trigger('click');
    });
    $('.header__search--backdrop').on('click', () => {
        $('.js-header-search-trigger:visible').trigger('click');
    });
}

function onSearchPopUpClose(user) {
    // Push to data layer
    var searchObj = $('body').find('input[name="q"]');
    dataLayer.push({
        'event': 'custom_event',
        'eventCategory': 'search',
        'eventAction': 'cancel_search',
        'eventLabel': 'cancel search',
        'searchTerm': searchObj.val() ? searchObj.val().trim() : '',
        'country': window.GlobalAttributes.COUNTRY,
        'language': window.GlobalAttributes.LANGUAGE,
        'screenName' : 'Search',
        'userType': user.user_id!='' ? 'logged-in' : 'logged-out',
        'userId': user.user_id!='' ? user.user_id : ''
    });
}

function maskCartIcon() {
    $('.header__mobile-trigger').on('click', () => {
        $('#mini-cart').toggleClass('cart-masked');
        $('.mega-item--active').removeClass('mega-item--active');
        $('.megamenu--prev-nav').removeClass('megamenu--prev-nav');
    });
}

function setPageUrlHistory() 
{
    try {
        if(window.innerWidth <= breakpoints.mobile) {
            var currentUrl = window.location.href;
            var previousUrl = document.referrer;
            if(currentUrl !== previousUrl) {
                var setUrlItem = checkValidPageUrl(currentUrl);
                if(!setUrlItem) {
                    setUrlItem = checkValidPageUrl(previousUrl);
                }
                if(setUrlItem) {
                    localStorage.setItem('pageurlhistory', setUrlItem);
                }
            }
        }
    } catch (e) {
    }
}

function checkValidPageUrl(url)
{
    var excludeUrls = ['Cart-SubmitForm','SGCart-SubmitForm','shopping-bag'];
    for(let i=0;i<excludeUrls.length;i++) {
        if(url.indexOf(excludeUrls[i]) !== -1) {
            return false;
        }
    }
    return url;
}

function initLazyImages()
{
    if(SitePreferences.ENABLE_IMAGE_LAZYLOAD ) {
        $('.logo__default:not(.unveil-loaded),.logo__sticky:not(.unveil-loaded)').unveil(0, function() {
            $(this).addClass('unveil-loaded');
        });
        $('img.asset-laz-load:not(.unveil-loaded)').unveil(200, function() {
            $(this).addClass('unveil-loaded');
        });
    }
}

function onSearchSuggestionClick() {
    $('.header__search,.header__mobile-search').on('click', '.search-suggestion-wrapper .hit', function (e) {
        // Push to data layer
        var user = dataLayer.find(o => o.user != null).user;
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'search',
            'eventAction': 'search_query_suggestion_click',
            'eventLabel': $(this).text(),//click text
            'searchTerm': $(this).text(),
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Search',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
        window.location = this.href;
    });
}
function getScreenName() {
	var pageName = pageContext.type;
	var screenName = '';
	if (pageName == 'storefront'|| pageName == 'homepage') {
		screenName = 'Home page';
	} else if (pageName == 'search') {
		screenName = 'Search';
	} else if (pageName == 'product') {
		screenName = 'PDP';
	} else if (pageName == 'Cart') {
		screenName = 'Cart page';
	} else if (pageName == 'checkout') {
		screenName = 'Checkout Page';
	} else if (pageName == 'MyAccount') {
		screenName = 'My Account';
	} else if (pageName == 'orderconfirmation') {
		screenName = 'Thank you screen';
	} 
	return screenName;
}

function headerGAEvents(){
    $('.header__user__item .header__user__link--account').on('click', function (e) {
        var user = dataLayer.find(o => o.user != null).user;
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation_account_click',
            'eventLabel': 'Signin/Register',
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    })
    $('.header__user__item .header__user__link--wishlist,.header__mobile-wishlist').on('click', function (e) {
        var user = dataLayer.find(o => o.user != null).user;
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation_wishlist_click',
            'eventLabel': 'top navigation wishlist click',
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    })
     
    $('.header__user__item.minicart .minicart__trigger').on('click', function (e) {
        var user = dataLayer.find(o => o.user != null).user;
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation_bag_click',
            'eventLabel': 'top navigation bag click',
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    })
    $('.flyout-col__all_item.level-3 .flyout-col__item-anchor').on('click', function (e) {
        var user = dataLayer.find(o => o.user != null).user;
        var level2Cat=$(this).closest('.level-3').find('.top--cat').text();
        var level1Cat=$(this).closest('.level-3').find('.level-1-cat').text();
        var level3Cat=$(this).text();
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation',
            'eventLabel': level1Cat +' > '+level2Cat + ' > '+level3Cat,
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    })
    $('.header__catmenu__item.level-1 .header__catmenu__anchor').on('click', function (e) {
        var user = dataLayer.find(o => o.user != null).user;
        var level1Cat=$(this).text();
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation',
            'eventLabel': level1Cat,
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    })
    $('.header__catmenu__item .header__catmenu__sub.level-2 .header__catmenu__sub__wrap .flyout-col-up__heading,.header__catmenu__item .header__catmenu__sub.level-2 .header__catmenu__sub__wrap .second-level-cat').on('click', function (e) {
        var user = dataLayer.find(o => o.user != null).user;
        var level1Cat=$(this).closest('.header__catmenu__sub.level-2').find('.level-2-heading').text();
        var level2Cat=$(this).text();
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation',
            'eventLabel': level1Cat +' > '+level2Cat,
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    })
    $('.header__logo__anchor').on('click', function (e) {
    	var user = dataLayer.find(o => o.user != null).user;
    	var screenName = getScreenName();
        dataLayer.push({
            'event':  'custom_event',
            'eventCategory': 'top_navigation',                   
            'eventAction': 'top_navigation_logo_click',
            'eventLabel': 'top navigation logo click',
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE, 
            'screenName' : screenName,
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',   
            'userId':user.user_id != '' ? user.user_id : ''               
        });
    });
    $('#countrySelectorList').on('change', function(){
    	var user = dataLayer.find(o => o.user != null).user;
    	var screenName = getScreenName();
    	var country = $('select#countrySelectorList option:selected').data('country');
    	dataLayer.push({
    	    'event':  'custom_event',
    	    'eventCategory': 'top_navigation',                   
    	    'eventAction': 'top_navigation_country_select',
    	    'eventLabel': country, //selected country
    	    'country': window.GlobalAttributes.COUNTRY,
    	    'language': window.GlobalAttributes.LANGUAGE, 
    	    'screenName' : screenName,
    	     'userType': user.user_id != '' ? 'logged-in' : 'logged-out',    
    	     'userId': user.user_id != '' ? user.user_id : ''              
    	});
    });
	$('.languageSelectorList').on('click', function () {
		var user = dataLayer.find(o => o.user != null).user;
		var screenName = getScreenName();
		var language = $(this).data('locale');
		dataLayer.push({
		    'event':  'custom_event',
		    'eventCategory': 'top_navigation',                   
		    'eventAction': 'top_navigation_language_click',
		    'eventLabel': language, // language
		    'country': window.GlobalAttributes.COUNTRY,
		    'language': window.GlobalAttributes.LANGUAGE, 
		    'screenName' : screenName,
		     'userType': user.user_id != '' ? 'logged-in' : 'logged-out',     
		     'userId': user.user_id != '' ? user.user_id : ''           
		});
	});
}

function toggleLanguagesMobile() {
    $('.language-accordion').on('click',function() {
        if(window.innerWidth < breakpoints.mobile) {
            $(this).parent().toggleClass('active');
        }
    });
}

function initFlyoutLazyLoad() {
    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
        let targetElements = document.querySelectorAll('.header__catmenu__sub.level-2');

        const callback = function(mutationsList, observer) {
            mutationsList.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    var element = mutation.target;
                    $(element).trigger('classChanged');
                }
            });
        };

        targetElements.forEach(function(element) {
            let observer = new MutationObserver(callback);
            observer.observe(element, {
                attributes: true,
                attributeFilter: ['class']
            });
        });

        $('.header__catmenu__sub.level-2').on('classChanged', function() {
            let $this = $(this);
            if ($this.hasClass('mega-item--active')) {
                $this.find('img[data-ondemandsrc]:not(.loaded-on-demand)').each(function() {
                    const srcVal = $(this).data('ondemandsrc')
                    $(this).attr('src', srcVal).addClass('loaded-on-demand');
                });
            }
        });
    }
}

function reinitFlyoutSlickOnResize() {
    $(window).on('resize', ()=> {
        $('.flyout-col__cta__interactive').slick('refresh');
    });
}

function initFlyoutImageCtaRedirect(){
    $(".flyout-col__cta__container").on('click','img',function(){
        if($(this).data('ctaurl')){
            window.location.href = $(this).data('ctaurl');
        }
    });
}

export default function(){
	//Initializing Megamenu with some custom classes
	mainNav  = new Megamenu(NAV_OPTIONS);
    fixedNav = new Fixit(FIXIT_OPTIONS);

    if(matContent) {
        welcomeMat = new Modal(MAT_OPTIONS);
    }

    if(signupContent) {
        signup = new Modal(SIGNUP_OPTIONS);
        addSignupHandler();
    }

    if (gdprContent) {
        gdprModal = new Modal(GDPR_OPTIONS);
    }

    togglePromoBanner();
    setNavInteractions();
    focusHeaderSearch();
    setPageUrlHistory();
    closeSearchPopup();
    initLazyImages();
    maskCartIcon();
    onSearchSuggestionClick();
    headerGAEvents();
    toggleLanguagesMobile();
    initFlyoutLazyLoad();
    reinitFlyoutSlickOnResize();
    initFlyoutImageCtaRedirect();
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/sections/header.js